import { api } from "./client.js";
import type { Role } from "@wwrp/shared";

export interface AuthUser {
  id: number;
  discordId: string;
  displayName: string;
  role: Role;
  trueRole: Role;
  viewingAsRole: Role | null;
  avatarUrl: string | null;
  /** Resolved hub permission flags for the current effective role. */
  permissions: Record<string, boolean>;
}

export const LOGIN_REDIRECT_KEY = "wwrp_login_redirect";

export const authApi = {
  /** GET /auth/me — null if not authenticated (401). */
  me: async (): Promise<AuthUser | null> => {
    try {
      return await api.get<AuthUser>("/auth/me");
    } catch {
      return null;
    }
  },

  /** Redirect to Discord OAuth start. */
  loginWithDiscord: () => {
    try {
      sessionStorage.setItem(LOGIN_REDIRECT_KEY, "1");
    } catch {
      // Ignore storage errors
    }
    window.location.href = "/api/auth/discord/start";
  },

  logout: () => api.post<{ ok: boolean }>("/auth/logout"),

  setViewAsRole: (role: Role) =>
    api.post<{ role: Role; viewingAsRole: Role }>("/auth/view-as-role", { role }),

  clearViewAsRole: () => api.delete<{ ok: boolean }>("/auth/view-as-role"),
};
